import React from 'react';
import PropTypes from 'prop-types';
import Select from 'react-select';
import forOwn from 'lodash/forOwn';

import mergeStates from '../../helpers/mergeStates';
import { fieldTypes, seperators, dates } from '../../models/NumberRange';
import inputFilter from '../../helpers/inputFilter';

import classes from './FormNumberRangeFieldEmbed.scss';

class FormNumberRangeFieldEmbed extends React.Component {
  handleFieldTypeChange = option => {
    const type = option.value;

    let value = '';
    if (type === 'interval') {
      value = {
        start: '1',
        end: '999',
        current: null,
      };
    }

    this.props.onChange(
      { ...this.props.field, type, value },
      this.props.position,
    );
  };

  handleValueChange = option => {
    let value = '';

    if (typeof option.target !== 'undefined') {
      value = option.target.value;
    } else {
      value = option.value;
    }

    this.props.onChange({ ...this.props.field, value }, this.props.position);
  };

  handleChange = e => {
    const nextState = mergeStates(e, this.props.field);
    this.props.onChange(nextState);
  };

  handleIntervalValueChange = (event, field) => {
    const nextValue = this.props.field.value;
    const fieldValue = event.target.value;

    if (field === 'start') {
      if (isNaN(fieldValue)) {
        nextValue.start = '';
      } else {
        nextValue.start = parseInt(fieldValue, 10).toString();
      }
    } else if (field === 'end') {
      if (isNaN(fieldValue)) {
        nextValue.end = '';
      } else {
        nextValue.end = parseInt(fieldValue, 10).toString();
      }
    }

    // // console.log(nextValue);

    this.props.onChange(
      { ...this.props.field, value: nextValue },
      this.props.position,
    );
  };

  renderStringValueField = () => (
    <input
      name="value"
      value={this.props.field.value}
      onKeyDown={e => inputFilter(e, 'alphanum')}
      onChange={e => this.handleValueChange(e)}
    />
  );

  renderDateValueField = () => {
    const dateOptions = [];
    forOwn(dates, item => {
      dateOptions.push({
        value: item.value,
        title: item.label,
        label: item.label,
      });
    });

    const placeholder = <span>Datum wählen</span>;
    return (
      <Select
        onChange={this.handleValueChange}
        options={dateOptions}
        placeholder={placeholder}
        value={this.props.field.value}
      />
    );
  };
  checkInterval = (event, field) => {
    const nextValue = this.props.field.value;
    const fieldValue = event.target.value;
    const intFieldValue = parseInt(fieldValue, 10);
    if (field === 'start') {
      if (intFieldValue >= parseInt(nextValue.end, 10)) {
        nextValue.end = (intFieldValue + 1).toString();
      }
      nextValue.start = parseInt(fieldValue, 10).toString();
    } else if (field === 'end') {
      if (intFieldValue <= parseInt(nextValue.start, 10)) {
        if (intFieldValue > 0) {
          nextValue.start = (intFieldValue - 1).toString();
        } else {
          nextValue.start = '0';
        }
      }
      nextValue.end = parseInt(fieldValue, 10).toString();
    }
    this.props.onChange(
      { ...this.props.field, value: nextValue },
      this.props.position,
    );
  };
  renderIntervalValueField = () => (
    <div className="row">
      <div className="col-sm-4">
        <input
          name="value.start"
          type="number"
          min="0"
          value={this.props.field.value.start}
          className="text-center"
          style={{ paddingRight: 0 }}
          onChange={e => this.handleIntervalValueChange(e, 'start')}
          onBlur={e => this.checkInterval(e, 'start')}
        />
      </div>
      <div className="col-sm-1 text-center">-</div>
      <div className="col-sm-4">
        <input
          name="value.end"
          type="number"
          min="0"
          value={this.props.field.value.end}
          className="text-center"
          style={{ paddingRight: 0 }}
          onChange={e => this.handleIntervalValueChange(e, 'end')}
          onBlur={e => this.checkInterval(e, 'end')}
        />
      </div>
    </div>
  );
  renderSeparatorValueField = () => {
    const seperatorOptions = [];
    seperators.forEach(item => {
      seperatorOptions.push({
        value: item.value,
        title: item.label,
        label: item.label,
      });
    });
    const placeholder = <span>Trennzeichen wählen</span>;
    return (
      <Select
        onChange={this.handleValueChange}
        options={seperatorOptions}
        placeholder={placeholder}
        value={this.props.field.value}
      />
    );
  };
  renderFieldValueFields = () => {
    const type = this.props.field.type;
    if (type === 'string') {
      return (
        <div className="row field-details-string">
          <div className="col-xs-10 col-sm-4">
            <label className="simpl-label">Zeichenkette</label>
          </div>
          <div className="col-xs-10 col-sm-7">
            {this.renderStringValueField()}
          </div>
        </div>
      );
    } else if (type === 'date') {
      return (
        <div className="row field-details-date">
          <div className="col-xs-10 col-sm-4">
            <label className="simpl-label">Datum</label>
          </div>
          <div className="col-xs-10 col-sm-7">
            {this.renderDateValueField()}
          </div>
        </div>
      );
    } else if (type === 'interval') {
      return (
        <div className="row field-details-interval">
          <div className="col-xs-10 col-sm-4">
            <label className="simpl-label">Intervall</label>
          </div>
          <div className="col-xs-10 col-sm-7">
            {this.renderIntervalValueField()}
          </div>
        </div>
      );
    } else if (type === 'seperator') {
      return (
        <div className="row field-details-seperator">
          <div className="col-xs-10 col-sm-4">
            <label className="simpl-label">Trennzeichen</label>
          </div>
          <div className="col-xs-10 col-sm-7">
            {this.renderSeparatorValueField()}
          </div>
        </div>
      );
    }
  };
  render() {
    const props = this.props;
    const label = `Feld ${props.position + 1}`;
    const placeholder = <span>Feldtyp wählen</span>;
    const fieldTypeOptions = [];
    forOwn(fieldTypes, data => {
      fieldTypeOptions.push({
        value: data.value,
        title: data.label,
        label: data.label,
      });
    });
    return (
      <div className={classes.fieldRow}>
        <div className="row">
          <div className="col-xs-12 col-sm-4">
            <label className="simpl-label">{label}</label>
          </div>
          <div className="col-xs-10 col-sm-7">
            <Select
              onChange={this.handleFieldTypeChange}
              options={fieldTypeOptions}
              placeholder={placeholder}
              value={this.props.field.type}
            />
          </div>
          <div className="col-xs-2 col-sm-1 text-right">
            <span
              className={classes.removeField}
              onMouseDown={e => this.props.onRemove(this.props.position)}
            >
              ×
            </span>
          </div>
        </div>
        {this.renderFieldValueFields()}
      </div>
    );
  }
}
FormNumberRangeFieldEmbed.propTypes = {
  onChange: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
  field: PropTypes.object.isRequired,
  position: PropTypes.number, // eslint-disable-line react/no-unused-prop-types
};
export default FormNumberRangeFieldEmbed;



// WEBPACK FOOTER //
// ./src/components/FormNumberRangeFieldEmbed/FormNumberRangeFieldEmbed.js